export default "__VITE_ASSET__e55bc64b__"